// extracted by mini-css-extract-plugin
module.exports = {"CommunityTrust":"CommunityTrust_CommunityTrust__eNw9_","images":"CommunityTrust_images__d26PO","title":"CommunityTrust_title__7rMMG"};